// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { collection, getDocs } from 'firebase/firestore';
// import { db } from '../../../firebase';
// import './blog.css';
// import LazyLoad from 'react-lazyload';
// import BlurhashImg from '../../../@/components/Image/BlurhashImg';

// const Blog = () => {
//   const [projects, setProjects] = React.useState([]);
//   const [loading, setLoading] = React.useState(true);
//   const [error, setError] = React.useState(null);

//   React.useEffect(() => {
//     const fetchProjects = async () => {
//       try {
//         const projectsCollection = collection(db, 'projects');
//         const snapshot = await getDocs(projectsCollection);
//         const fetchedProjects = snapshot.docs.map(doc => {
//           const data = doc.data();
//           return { id: doc.id, ...data };
//         });

//         fetchedProjects.sort((a, b) => (b.createdAt?.toDate() || 0) - (a.createdAt?.toDate() || 0));
//         setProjects(fetchedProjects);
//       } catch (error) {
//         console.error("Error fetching projects:", error);
//         setError("Failed to load projects. Please try again later.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProjects();
//   }, []);

//   if (loading) return <div>Loading projects...</div>;
//   if (error) return <div>Error: {error}</div>;

//   const visibleProjects = projects.filter(project => project.isVisible);
//   const featuredProject = visibleProjects[0];

//   const getProjectLink = (project) => {
//     return project.slug ? `/work/${project.slug}` : `/work/${project.id}`;
//   };

//   return (
//     <div className="container mx-auto px-8 py-16">
//     {/* <div className='img'> */}
//       <div
//           className="category-buttons"
//       >
//         <h1 className="" style={{fontFamily: "Poppins-SemiBold", color: "#CD3333", fontSize: "37px", fontWeight: "600", lineHeight: "1.1"}}>Discover <br/> Design Case Studies</h1>
//           <button className='btn2' style={{marginLeft: 'auto', marginTop: 'auto'}}>
//             <Link to="/work" style={{fontFamily: "Poppins-Light", color: '#000000' }}>
//               View all Case Studies
//             </Link>
//           </button>
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-2">
//         {/* Featured Project Column */}
//         <div className="featured-column">
//           {featuredProject && (
//             <Link 
//               to={getProjectLink(featuredProject)} 
//               className="block h-full"
//             >
//               <div className="featured-project-card h-full bg-white overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
//                 <div className="relative h-full">
//                   <BlurhashImg 
//                     src={featuredProject.coverImage} 
//                     placeholderColor="#888"
//                     className="w-full h-full object-cover"
//                   />
//                   <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
//                     <h2 className="text-white text-2xl font-bold mb-2">
//                       {featuredProject.title}
//                     </h2>
//                     <p className="text-white mb-2">
//                       {featuredProject.description}
//                     </p>
//                     <p className="text-white">
//                       {featuredProject.location}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </Link>
//           )}
//         </div>

//         {/* Other Projects Column */}
//         {/* Other Projects Column */}
//         <div className="projects-column">
//           <div className="grid grid-cols-2 gap-4">
//             {visibleProjects.slice(1, 5).map((project) => (
//               <Link 
//                 key={project.id} 
//                 to={getProjectLink(project)} 
//                 className="block"
//               >
//                 <div className="project-card bg-white overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
//                   <div className="relative">
//                     {project.coverImage ? (
//                       <BlurhashImg 
//                         src={project.coverImage} 
//                         placeholderColor="#888"
//                         className="w-full aspect-square object-cover" 
//                         onError={(e) => {
//                           console.error('Error loading image:', project.coverImage);
//                           e.target.src = '/fallback-image.jpg'; 
//                         }}
//                       />
//                     ) : (
//                       <div className="w-full aspect-square bg-gray-200 flex items-center justify-center">
//                         No Image Available
//                       </div>
//                     )}
//                   </div>
//                   {/* Display the project title below the image */}
//                   <div className="p-2">
//                     <h2 className="text-black text-base font-bold mb-1 text-center"> 
//                       {project.title || 'Untitled Project'}
//                     </h2>
//                   </div>
//                 </div>
//               </Link>
//             ))}
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default Blog;







// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
// import { db } from '../../../firebase';
// import './blog.css';
// import BlurhashImg from '../../../@/components/Image/BlurhashImg';

// const Blog = () => {
//   const [projects, setProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [debugInfo, setDebugInfo] = useState({});

//   useEffect(() => {
//     const fetchProjects = async () => {
//       try {
//         // Log the database connection
//         console.log('Database connection:', !!db);

//         const projectsCollection = collection(db, 'projects');
//         console.log('Attempting to fetch projects...');

//         // Add query constraints to ensure we get data
//         const projectsQuery = query(
//           projectsCollection,
//           orderBy('createdAt', 'desc')
//         );

//         const snapshot = await getDocs(projectsQuery);
//         console.log('Snapshot size:', snapshot.size);
//         console.log('Snapshot empty:', snapshot.empty);

//         const fetchedProjects = snapshot.docs.map(doc => {
//           const data = doc.data();
//           console.log(`Project ${doc.id}:`, data);
          
//           // Set default values for required fields
//           return {
//             id: doc.id,
//             title: data.title || 'Untitled Project',
//             coverImage: data.coverImage || '',
//             isVisible: data.isVisible === undefined ? true : data.isVisible,
//             slug: data.slug || doc.id,
//             createdAt: data.createdAt,
//             ...data
//           };
//         });

//         console.log('Fetched projects:', fetchedProjects);

//         // Store debug info
//         setDebugInfo({
//           totalProjects: fetchedProjects.length,
//           visibleProjects: fetchedProjects.filter(p => p.isVisible).length,
//           projectsWithImages: fetchedProjects.filter(p => p.coverImage).length
//         });

//         setProjects(fetchedProjects);
//       } catch (error) {
//         console.error("Error details:", {
//           message: error.message,
//           code: error.code,
//           stack: error.stack
//         });
//         setError("Failed to load projects. Please try again later.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProjects();
//   }, []);

//   // Debug render to show data state
//   if (loading) {
//     return <div className="text-center p-4">Loading projects...</div>;
//   }

//   if (error) {
//     return (
//       <div className="text-center p-4 text-red-600">
//         <p>Error: {error}</p>
//         <pre className="text-sm mt-2">{JSON.stringify(debugInfo, null, 2)}</pre>
//       </div>
//     );
//   }

//   const visibleProjects = projects.filter(project => project.isVisible);
//   console.log('Visible projects:', visibleProjects);

//   const featuredProject = visibleProjects[0];
//   console.log('Featured project:', featuredProject);

//   // Show debug info if no projects
//   if (!visibleProjects.length) {
//     return (
//       <div className="mx-auto section__padding">
//         <div className="text-center p-4">
//           <h2>No Projects Available</h2>
//           <pre className="text-sm mt-2 text-left">
//             Debug Info:
//             {JSON.stringify(debugInfo, null, 2)}
//           </pre>
//         </div>
//       </div>
//     );
//   }

//   const getProjectLink = (project) => {
//     return project.slug ? `/work/${project.slug}` : `/work/${project.id}`;
//   };

//   return (
//     <div className="mx-auto section__padding-blog">
//       <div className="category-buttons-blog mb-36">
//         <h1 style={{ 
//         }}>
//           Discover <br /> Design Case Studies
//         </h1>
//         <button 
//           className='btn2' 
//           style={{ marginTop: 'auto' }}
//         >
//           <Link 
//             to="/work" 
//             style={{ 
//               fontFamily: "Poppins-Light", 
//               color: '#000000' 
//             }}
//           >
//             View all Case Studies
//           </Link>
//         </button>
//       </div> 
//       <p className="width-p">
//         Designed to the exacting European Designed to the exacting European Passive House Standard, this is architect Cedric Burgers’s family home, Passive House Standard, this is architect Cedric Burgers’s family home,
//       </p>



//       {/* Debug info */}
//       {/* {process.env.NODE_ENV === 'development' && (
//         <div className="bg-gray-100 p-2 mb-4 text-xs">
//           <pre>{JSON.stringify(debugInfo, null, 2)}</pre>
//         </div>
//       )} */}

//     <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-2">
//       {/* Featured Project Column */}
//       {featuredProject && (
//         <div className="featured-column">
//           <Link to={getProjectLink(featuredProject)} className="block h-full">
//             <div 
//               className="relative h-full group"
//               style={{ backgroundColor: 'transparent' }}
//             >
//               <div className="h-full overflow-hidden transition-shadow duration-300">
//                 {featuredProject.coverImage ? (
//                   <BlurhashImg
//                     src={featuredProject.coverImage}
//                     placeholderColor="#888"
//                     className="w-full h-full object-cover"
//                     onError={(e) => {
//                       console.error('Error loading featured image:', featuredProject.coverImage);
//                       e.target.src = '/fallback-image.jpg';
//                     }}
//                   />
//                 ) : (
//                   <div className="w-full h-full bg-gray-200 flex items-center justify-center">
//                     <span className="text-gray-500">No Image Available</span>
//                   </div>
//                 )}
//               </div>
//               <div className="absolute bottom-0 left-0 right-0 p-4 bg-white">
//                 <h2 
//                   className="text-black text-xl font-semibold truncate"
//                   style={{ fontFamily: "Poppins-SemiBold", fontSize: '16px' }}
//                 >
//                   {featuredProject.title}
//                 </h2>
//               </div>
//             </div>
//           </Link>
//         </div>
//       )}

//       {/* Other Projects Column */}
//       <div className="projects-column">
//         <div className="grid grid-cols-2 gap-4">
//           {visibleProjects.slice(1, 5).map((project) => (
//             <Link 
//               key={project.id} 
//               to={getProjectLink(project)} 
//               className="block h-full"
//             >
//               <div className="relative h-full">
//                 <div className="h-full overflow-hidden">
//                   {project.coverImage ? (
//                     <BlurhashImg
//                       src={project.coverImage}
//                       placeholderColor="#888"
//                       className="w-full h-full object-cover"
//                       onError={(e) => {
//                         console.error('Error loading image:', project.coverImage);
//                         e.target.src = '/fallback-image.jpg';
//                       }}
//                     />
//                   ) : (
//                     <div className="w-full h-full bg-gray-200 flex items-center justify-center">
//                       <span className="text-gray-500">No Image Available</span>
//                     </div>
//                   )}
//                 </div>
//                 <div className="absolute bottom-0 left-0 right-0 p-4 bg-white">
//                   <h2 
//                     className="text-black text-lg font-semibold truncate"
//                     style={{ fontFamily: "Poppins-SemiBold", fontSize: '16px' }}
//                   >
//                     {project.title}
//                   </h2>
//                 </div>
//               </div>
//             </Link>
//           ))}
//         </div>
//       </div>
//     </div>
//     </div>
//   );
// };

// export default Blog;











import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
import { db } from '../../../firebase';
import './blog.css';
import BlurhashImg from '../../../@/components/Image/BlurhashImg';

const Blog = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [debugInfo, setDebugInfo] = useState({});

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        // Log the database connection
        console.log('Database connection:', !!db);

        const projectsCollection = collection(db, 'projects');
        console.log('Attempting to fetch projects...');

        // Add query constraints to ensure we get data
        const projectsQuery = query(
          projectsCollection,
          orderBy('createdAt', 'desc')
        );

        const snapshot = await getDocs(projectsQuery);
        console.log('Snapshot size:', snapshot.size);
        console.log('Snapshot empty:', snapshot.empty);

        const fetchedProjects = snapshot.docs.map(doc => {
          const data = doc.data();
          console.log(`Project ${doc.id}:`, data);
          
          // Set default values for required fields
          return {
            id: doc.id,
            title: data.title || 'Untitled Project',
            coverImage: data.coverImage || '',
            isVisible: data.isVisible === undefined ? true : data.isVisible,
            slug: data.slug || doc.id,
            createdAt: data.createdAt,
            ...data
          };
        });

        console.log('Fetched projects:', fetchedProjects);

        // Store debug info
        setDebugInfo({
          totalProjects: fetchedProjects.length,
          visibleProjects: fetchedProjects.filter(p => p.isVisible).length,
          projectsWithImages: fetchedProjects.filter(p => p.coverImage).length
        });

        setProjects(fetchedProjects);
      } catch (error) {
        console.error("Error details:", {
          message: error.message,
          code: error.code,
          stack: error.stack
        });
        setError("Failed to load projects. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  // Debug render to show data state
  if (loading) {
    return <div className="text-center p-4">Loading projects...</div>;
  }

  if (error) {
    return (
      <div className="text-center p-4 text-red-600">
        <p>Error: {error}</p>
        <pre className="text-sm mt-2">{JSON.stringify(debugInfo, null, 2)}</pre>
      </div>
    );
  }

  const visibleProjects = projects.filter(project => project.isVisible);
  console.log('Visible projects:', visibleProjects);

  const featuredProject = visibleProjects[0];
  console.log('Featured project:', featuredProject);

  // Show debug info if no projects
  if (!visibleProjects.length) {
    return (
      <div className="mx-auto section__padding">
        <div className="text-center p-4">
          <h2>No Projects Available</h2>
          <pre className="text-sm mt-2 text-left">
            Debug Info:
            {JSON.stringify(debugInfo, null, 2)}
          </pre>
        </div>
      </div>
    );
  }

  const getProjectLink = (project) => {
    return project.slug ? `/work/${project.slug}` : `/work/${project.id}`;
  };

  return (
    <>
    <div className="mx-auto section__padding-blog">
      <div className="category-buttons-blog mb-36">
        <h1 style={{ 
        }}>
          Discover <br /> Design Case Studies
        </h1>
        <button 
          className='btn2' 
          style={{ marginTop: 'auto' }}
        >
          <Link 
            to="/work" 
            style={{ 
              fontFamily: "Poppins-Light", 
              color: '#000000' 
            }}
          >
            View all Case Studies
          </Link>
        </button>
      </div> 
      <p className="width-p_blog">
        Designed to the exacting European Designed to the exacting European Passive House Standard, this is architect Cedric Burgers’s family home, Passive House Standard, this is architect Cedric Burgers’s family home,
      </p>



      {/* Debug info */}
      {/* {process.env.NODE_ENV === 'development' && (
        <div className="bg-gray-100 p-2 mb-4 text-xs">
          <pre>{JSON.stringify(debugInfo, null, 2)}</pre>
        </div>
      )} */}

    {/* First Section */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Featured Project */}
        <div className="md:col-span-2 lg:col-span-2 lg:row-span-2 md:h-[600px] h-[290px]">
          {featuredProject && (
            <Link to={getProjectLink(featuredProject)} className="block h-full">
              <div className="relative h-full group">
                <div className="absolute inset-0 overflow-hidden">
                  <BlurhashImg
                    src={featuredProject.coverImage}
                    placeholderColor="#888"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4" style={{background: "#E9E9E1", opacity: "0.95"}}>
                  <h2 className="text-black text-lg font-semibold truncate">
                    {featuredProject.title}
                  </h2>
                </div>
              </div>
            </Link>
          )}
        </div>

        {/* Grid of Projects */}
        {visibleProjects.slice(0, 4).map((project, index) => (
          <div 
            key={project.id} 
            className={`h-[290px] ${
              index === 0 ? 'md:col-start-3' : 
              index === 1 ? 'md:col-start-4' : 
              index === 2 ? 'md:col-start-3 md:row-start-2' : 
              'md:col-start-4 md:row-start-2'
            }`}
          >
            <Link to={getProjectLink(project)} className="block h-full">
              <div className="relative h-full">
                <div className="absolute inset-0 overflow-hidden">
                  <BlurhashImg
                    src={project.coverImage}
                    placeholderColor="#888"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4" style={{background: "#E9E9E1", opacity: "0.95"}}>
                  <h2 className="text-black text-lg font-semibold truncate">
                    {project.title}
                  </h2>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
    <div classname="divide" style={{ maxHeight: '750px', overflowY: 'auto', borderTop: "1px solid #000", margin: "4rem 2rem 0rem 2rem" }}></div>
    </>
  );
};

export default Blog;